module.exports = __webpack_public_path__ + "img/cup.2c565e79.png";